export type Market = 'AU' | 'HK' | 'ID' | 'MY' | 'NZ' | 'PH' | 'SG' | 'TH';

export enum MarketLocationIds {
  AU = '3000',
  HK = '24469',
  ID = '24473',
  MY = '24500',
  NZ = '3001',
  PH = '24534',
  SG = '24553',
  TH = '24572',
}

export enum MarketCurrency {
  AU = 'AUD',
  HK = 'HKD',
  ID = 'IDR',
  MY = 'MYR',
  NZ = 'NZD',
  PH = 'PHP',
  SG = 'SGD',
  TH = 'THB',
}
